/* eslint-disable */
import {
  call,
  TransactionItemsForCommentResponse,
  CreateTransactionBody
} from 'services/api-service'

/**
 * Post a transaction (js feed) and get items for user to comment on
 *
 * @method
 * @name ApiService#createTransactionAndGetItemsForComment
 * @param {CreateTransactionBody} body -
 */
function createTransactionAndGetItemsForComment(
  body: CreateTransactionBody
): Promise<TransactionItemsForCommentResponse> {
  return call<TransactionItemsForCommentResponse>(
    'POST',
    '/{siteKey}/transaction/itemsForComment/{locale}',
    {},
    [],
    [],
    [],
    body
  )
}

export default { createTransactionAndGetItemsForComment }
